import React from 'react';
import SubPage from '../components/SubPage';
import { subPages } from '../subpages';

export default function AiAutomationPage() {
  return <SubPage data={subPages['ai-and-automation']} />;
}
